import { rankingCommonConfig } from './common'
import type { RankingPageConfig } from './types'
import { resources as brandResources } from '@/config/brands'

export const theme = {
  rankGradient: 'linear-gradient(0deg, #6E67FC 0%, #A559F6 100%)',
  medalNumberTop: '-3px',
} as const

export const resources = {
  homeBg: '/images/talewave/home-bg.webp',
  spikeletL: '/images/talewave/ranking/spikelet_l.png',
  spikeletR: '/images/talewave/ranking/spikelet_r.png',
  goldMedal: brandResources.medals.goldMedal,
  silverMedal: brandResources.medals.silverMedal,
  bronze: brandResources.medals.bronze,
  medal: brandResources.medals.medal,
} as const

export const rankingConfig: RankingPageConfig = {
  theme,
  resources,
  texts: rankingCommonConfig.texts,
}
